<script>
  export let content = {
    images: [
      {
        media: '',
        src: '',
        alt: ''
      }
    ]
  };
</script>
<div class="mt-[-10rem] z-10 relative">
  <div class="w-full flex items-center justify-center bg-cover bg-center bg-no-repeat h-[13.5rem] sm:h-[25.1rem] md:h-[25.7rem] lg:h-[31.5rem] lg:mt-[-12rem] xl:h-[35.6rem] bg-[url('/assets-mkt/routes/home/thick_green_wave_v2_1x.svg')] sm:bg-[url('/assets-mkt/routes/home/thick_green_wave_v2_2x.svg')] md:bg-[url('/assets-mkt/routes/home/thick_green_wave_v2_3x.svg')] lg:bg-[url('/assets-mkt/routes/home/thick_green_wave_v2_4x.svg')] xl:bg-[url('/assets-mkt/routes/home/thick_green_wave_v2_5x.svg')]">
    <picture class="w-[30rem] mt-12 sm:w-[53rem] sm:mt-20 md:w-[109rem]">
      {#each content.images as image}
        <source media="{image.media}" srcset="{image.src}" />
        {/each}
      <img class="w-full" width="428" height="69" src="{content.images[0].src}" alt="{content.images[0].alt}">
    </picture>
  </div>
</div>
